import React, { useState, useLayoutEffect } from 'react'

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}
const Features = (props) => {
    const { subMenuList } = props['featureMenuList']['items'];
    const [windWidth, winHeight] = useWindowSize();

    return (
        <>
            <div id={`accordion_${props['featureMenuList']['id']}`} tabIndex="-1" className='menu' onClick={props.handleAccordian} onKeyDown={(e) => {
                if (e.key != 'Enter') {
                    return
                } props.accordionMenu(e)
            }}>
                <div className={`icon`} ></div>
                {/* <div className={`mob_icon mob_icon_${list.id}`}></div> */}
                <div className='text'>{(!window.mob && window.innerWidth > window.innerHeight) && props.orentation == 90 ? props['featureMenuList'].title : props['featureMenuList'].mobileTitle}</div>
                <div className='dds__side-nav__group__chevron'><svg viewBox="0 0 32 32" className="dds__side-nav__group__chevron" aria-hidden="true" focusable="false"><title>$dds__chevron-down</title><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg></div>
            </div>

            <div className='accordionContent' style={{ height: '0px' }}>
                <ul className='subMenu'>
                    {
                        props['featureMenuList']['items'] && props['featureMenuList']['items'].map((list) => {
                            return (
                                list.Visibility=="show" && <div key={list.id}>
                                <li className='subMenuBtn' id={`menu_id_${list.id}`} onKeyDown={(e) => {
                                    if (e.key != 'Enter') {
                                        return
                                    } props.handleAdditionalMenuClick(list)
                                }} onClick={() => {
                                    props.handleAdditionalMenuClick(list)
                                }} >
                                    <div>
                                        {((window.mob || window.innerHeight > window.innerWidth) && props.orentation == 0) || windWidth < 715 ?
                                            <div className='accordia_icon'><img className='arrow' src='images/spacer.png' id={`accordianIcon_${list.id}`} />
                                            </div> : null}
                                        {list.title}
                                    </div>
                                </li>
                            </div>
                            )
                        })
                    }

                </ul>
            </div>
        </>
    )
}

export default Features